export default __webpack_public_path__ + "static/3-e7853545486fb93b6464e4f6b2679d43.jpg";